module.exports = __webpack_public_path__ + "img/major.989c3177.png";